import React from 'react'
import PropTypes from 'prop-types'
import BackButtonStyled from './BackButton.styled'

const BackButton = ({ onClick, children, elementRef, className = '' }) => (
  <BackButtonStyled
    type="button"
    className={`gtm-linkclick cta-link ${className}`}
    ref={elementRef}
    onClick={() => {
      onClick()
    }}
  >
    <svg
      aria-hidden="true"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.70711 1.70711C7.09763 1.31658 7.09763 0.683417 6.70711 0.292893C6.31658 -0.0976311 5.68342 -0.0976311 5.29289 0.292893L0.292893 5.29289C-0.0976311 5.68342 -0.0976311 6.31658 0.292893 6.70711L5.29289 11.7071C5.68342 12.0976 6.31658 12.0976 6.70711 11.7071C7.09763 11.3166 7.09763 10.6834 6.70711 10.2929L3.41421 7H13C13.5523 7 14 6.55228 14 6C14 5.44772 13.5523 5 13 5H3.41421L6.70711 1.70711Z"
        fill="#008755"
      />
    </svg>
    {children ? children : <>Back to my deliveries</>}
  </BackButtonStyled>
)

export default BackButton

BackButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  elementRef: PropTypes.object,
  className: PropTypes.string,
}
